const LangForgotEmail = {
	"forgotEmail._title": ["FORGOT YOUR EMAIL", "ភ្លេច​អ៊ីម៉ែល​"],
	"forgotEmail._message": [
		`<p>
			Please contact our Customer Care at
			<span class="d-inline-block">023 986 591</span>
			or
			<span class="word-break-all">
			customerservice@starbucksrewards.com.kh
			</span>.
		</p>
		<p>
			We will provide assistance on retrieving login information.
		</p>`,
		`<p>
			សូម​ទាក់​ទង​​ផ្នែក​បម្រើ​សេវា​អតិថិជន​របស់​យើង​ខ្ញុំ​ តាម​ទូរស័ព្ទ​ 
			<span class="d-inline-block">023 986 591</span>
			ឬ​អ៊ី​ម៉ែល
			<span class="word-break-all">
			customerservice@starbucksrewards.com.kh
			</span>
		</p>
		<p>
		។ យើង​ខ្ញុំ​នឹង​ជួយ​​ក្នុង​ការ​ទាញ​យក​ព័ត៌មាន ​សម្រាប់​ចូល​គណនី​ជូន​​លោក​អ្នក ។
		</p>`,
	],
}

export default LangForgotEmail



// WEBPACK FOOTER //
// ./src/resources/pages/LangForgotEmail.js